import { BrowserRouter as Router } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { LocalizationProvider } from "@mui/x-date-pickers-pro/LocalizationProvider";
import { AdapterDateFns } from "@mui/x-date-pickers-pro/AdapterDateFns";
import { muiLicense } from "@diligentcorp/atlas-mui-license";
import { AtlasThemeProvider } from "@diligentcorp/atlas-theme-mui";
import { lensThemeOptions } from "@diligentcorp/atlas-theme-mui/lib/themes/lens/index.js";
import { createLensDataGridThemeOptions } from "@diligentcorp/atlas-theme-mui-data-grid/lib/index.js";
import { createLensDatePickerThemeOptions } from "@diligentcorp/atlas-theme-mui-date-pickers/lib/index.js";

import Layout from "./components/Layout";
import AppRoutes from "./routes/AppRoutes";
import { createTabsThemeOverride } from "./themes/tabsThemeOverride";
import { ErrorDialogProvider } from "./contexts/ErrorDialogContext";
import { OidcAuthProvider } from "./contexts/OidcAuthContext";

// Apply Diligent Corp MUI Pro license
muiLicense.apply();

// Create React Query client
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <OidcAuthProvider>
        <AtlasThemeProvider
          themeOptions={lensThemeOptions}
          themeExtensions={[
            createLensDataGridThemeOptions,
            createLensDatePickerThemeOptions,
            createTabsThemeOverride,
          ]}
        >
          <LocalizationProvider dateAdapter={AdapterDateFns}>
            <ErrorDialogProvider>
              <Router>
                <Layout>
                  <AppRoutes />
                </Layout>
              </Router>
            </ErrorDialogProvider>
          </LocalizationProvider>
        </AtlasThemeProvider>
      </OidcAuthProvider>
    </QueryClientProvider>
  );
}

export default App;
